module.exports = __webpack_public_path__ + "static/fc_chacha_1-72201e530e3f338932c2ce567864d124.mp4";